import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/increase-vinted-sales';

export default function Example() {
  return (
    <>
      <Head>
        <title>The Best Ways to Boost Your Vinted Sales</title>
        <meta
          name='description'
          content='Great strategies lead to increase in sales. Learn here how you can boost your sales on Vinted!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/increase-vinted-sales' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/increase-vinted-sales' />
        <meta property='og:title' content='The Best Ways to Boost Your Vinted Sales' />
        <meta
          property='og:description'
          content='Great strategies lead to increase in sales. Learn here how you can boost your sales on Vinted!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='Vinted' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
